import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


export default new Vuex.Store({
    // state: {
    //     chooseList3: [],
    //     chooseList4: [],
    //     chooseList: [],
    //     chooseList2: [],


    //     newsDetail: [],
    //     cityName: '',
    //     cityIDX: ''
    // },

    state: sessionStorage.getItem('state') ? JSON.parse(sessionStorage.getItem('state')) : {
        chooseList5: [],
        chooseList: [],
        chooseList4: [],
        chooseList3: [],
        chooseList2: [],
        newsDetail: [],
        CompanynewsDetail: [],
        chapterList1: [],
        chapterList2: [],
        chapterList3: [],
        chapterList4: [], //4个科一专项
        chapterList5: [],
        chapterList6: [],
        chapterList7: [],
        chapterList8: [],
        chapterList9: [],
        chapterList10: [],
        chapterList11: [], //7个科四专项
        moniList1: [], //模拟
        moniList4: [],

        cityName: '',
        cityIDX: {
            name: ''
        }
    },

    mutations: {
        setChoose(state, data) {
            state.chooseList = data;
        },
        setChoose4(state, data) {
            state.chooseList4 = data;
        },
        setChoose5(state, data) {
            state.chooseList5 = data;
        },
        setChoose2(state, data) {
            state.chooseList2 = data;
        },
        setChoose3(state, data) {
            state.chooseList3 = data;
        },
        setChapter1(state, data) {
            state.chapterList1 = data;
        },
        setChapter2(state, data) {
            state.chapterList2 = data;
        },
        setChapter3(state, data) {
            state.chapterList3 = data;
        },
        setChapter4(state, data) {
            state.chapterList4 = data;
        },
        setChapter5(state, data) {
            state.chapterList5 = data;
        },
        setChapter6(state, data) {
            state.chapterList6 = data;
        },
        setChapter7(state, data) {
            state.chapterList7 = data;
        },
        setChapter8(state, data) {
            state.chapterList8 = data;
        },
        setChapter9(state, data) {
            state.chapterList9 = data;
        },
        setChapter10(state, data) {
            state.chapterList10 = data;
        },
        setChapter11(state, data) {
            state.chapterList11 = data;
        },
        setMoni1(state, data) {
            state.moniList1 = data;
        },
        setMoni4(state, data) {
            state.moniList4 = data;
        },
        getNews(state, data) {
            state.newsDetail = data;
        },
        getCompanyNews(state, data) {
            state.CompanynewsDetail = data;
        },

        getCname(state, data) {
            state.cityName = data;
        },
        getCtyid(state, data) {

            //state.cityIDX=data;
            //Vue.set(state, 'cityIDX', data);
            //state.splice(state.cityIDX, 1, data);
            Vue.set(state.cityIDX, 'name', data)
                //state.splice(state.cityIDX, 1, data)

        },
    },
    actions: {
        asyncInrement(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChoose');
                    resolve();
                }, 1000)
            });
        },
        asyncInrement2(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChoose2');
                    resolve();
                }, 1000)
            });
        },
        asyncInrement3(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChoose3');
                    resolve();
                }, 1000)
            });
        },
        asyncInrement5(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChoose5');
                    resolve();
                }, 1000)
            });
        },
        asyncInrement4(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChoose4');
                    resolve();
                }, 1000)
            });
        },
        Chapter1(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChapter1');
                    resolve();
                }, 1000)
            });
        },
        Chapter2(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChapter2');
                    resolve();
                }, 1000)
            });
        },
        Chapter3(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChapter3');
                    resolve();
                }, 1000)
            });
        },
        Chapter4(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChapter4');
                    resolve();
                }, 1000)
            });
        },
        Chapter5(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChapter5');
                    resolve();
                }, 1000)
            });
        },
        Chapter6(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChapter6');
                    resolve();
                }, 1000)
            });
        },
        Chapter7(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChapter7');
                    resolve();
                }, 1000)
            });
        },
        Chapter8(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChapter8');
                    resolve();
                }, 1000)
            });
        },
        Chapter9(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChapter9');
                    resolve();
                }, 1000)
            });
        },
        Chapter10(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChapter10');
                    resolve();
                }, 1000)
            });
        },
        Chapter11(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('setChapter11');
                    resolve();
                }, 1000)
            });
        },
        // Moni1(context) {
        //     return new Promise(resolve => {
        //         setTimeout(() => {
        //             context.commit('setMoni1');
        //             resolve();
        //         }, 1000)
        //     });
        // },
        Moni1({ commit }, targetUser) {
            commit("setMoni1", targetUser);
            // localStorage.setItem("SET_TARGET_USER", JSON.stringify(targetUser));
        },
        Moni4({ commit }, targetUser) {
            commit("setMoni4", targetUser);
            // localStorage.setItem("SET_TARGET_USER", JSON.stringify(targetUser));
        },

        newsment(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('getNews');

                    resolve();
                }, 1000)
            });
        },
        Companynewsment(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('getCompanyNews');

                    resolve();
                }, 1000)
            });
        },

        cityment(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('getCname');
                    resolve();
                }, 1000)
            });
        },
        cityidment(context) {
            return new Promise(resolve => {
                setTimeout(() => {
                    context.commit('getCtyid');
                    resolve();
                }, 1000)
            });
        },
    },
    modules: {}
})